
import React, { useEffect, useState } from "react"
import DataTable from "react-data-table-component"
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap"
import { Card } from "primereact/card"
import Select from "react-select"
import { Link } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
const customStylesForRectSelect = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "34px",
    height: "34px",
    textWrap: "nowrap",
    overflow: "hidden",
    fontSize: "0.85rem",
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: base => ({ ...base, zIndex: 9999 }),
  placeholder: base => ({
    ...base,
    color: "#66686b",
  }),
}
const mapReferralRow = referral => ({
  id: referral.id,
  job_reference_by: referral.referred_by_name,
  job_reference_ID: referral.referred_by_employee_code,
  resume: referral.resume_url,
  job_candidate_name: referral.candidate_name,
  job_id: referral.job_id,
  job_title: referral.job_title,
  referred_on: new Date(referral.created_at).toLocaleDateString(),
  referreal_select_status: referral.status,
})

const AllReferralCandidates = () => {
  document.title = "ATS - Referral Candidates";
  const [hrRemarks, setHrRemarks] = useState("")
  const [hrRemarksReject, setHrRemarksReject] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [AllReferralCandy, setAllReferralCandy] = useState([])
  const [selectedCandidateFilter, setSelectedCandidateFilter] = useState(null)
  const [selectedJob, setSelectedJobFilter] = useState(null)
  const [selectedReferredBy, setSelectedReferredByFilter] = useState(null)
  const [selectedStatus, setSelectedStatusFilter] = useState(null)
  const [candidates, setCandidates] = useState([])
  const [jobs, setJobs] = useState([])
  const [referredBy, setReferredBy] = useState([])
  const [statuses, setStatuses] = useState(["Pending", "Approved", "Rejected"])
  const [selectedCandidateApprove, setSelectedCandidateApprove] = useState(null)
  const [selectedCandidateReject, setSelectedCandidateReject] = useState(null)
  const [ViewCandidateInfoPopup, setViewCandidateInfoPopup] = useState(false)
  const [loadingList, setLoadingList] = useState(false)
  const [loadingDropdown, setLoadingDropdown] = useState(false)
  const [loadingAction, setLoadingAction] = useState(false)
  const [ViewCandidateApprovePopup, setViewCandidateApprovePopup] =
    useState(false)
  const [ViewCandidateRejectPopup, setViewCandidateRejectPopup] =
    useState(false)
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoadingDropdown(true)
      try {
        const response = await axios.get("api/v1/referral-dropdown/")
        setCandidates(response.data.candidates)
        setJobs(response.data.jobs)
        setReferredBy(response.data.referred_by)
      } catch (error) {
        console.error("Error fetching dropdown data:", error)
      } finally {
        setLoadingDropdown(false)
      }
    }
    fetchDropdownData()
  }, [])
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
  const fetchReferralList = async () => {
    setLoadingList(true)
    try {
      let url = "/api/v1/referral-list/"
      const params = new URLSearchParams()
      params.append("limit", rowsPerPage);
      params.append("offset", (currentPage - 1) * rowsPerPage); 
      if (selectedCandidateFilter)
        params.append("candidate_id", selectedCandidateFilter.value)
      if (selectedJob) params.append("job_id", selectedJob.value)
      if (selectedReferredBy)
        params.append("referred_by_id", selectedReferredBy.value)
      if (selectedStatus) params.append("status", selectedStatus.value)
      if (params.toString()) url += `?${params.toString()}`
      const response = await axios.get(url)
      const referrals = response.data.results.map(mapReferralRow);
      setAllReferralCandy(referrals)
      setTotalCount(response.data.count);
    } catch (error) {
      console.error("Error fetching referral list:", error)
    } finally {
      setLoadingList(false)
    }
  }
  useEffect(() => {
    fetchReferralList()
  }, [selectedCandidateFilter, selectedJob, selectedReferredBy, selectedStatus,currentPage,rowsPerPage])
  // useEffect(() => {
  //   setAllReferralCandy([])
  //   fetchReferralList()
  // }, [])
  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info") || "{}")
  const handleApproveRequest = async (referralId, hrRemarks) => {
    setLoading(true)
    try {
      const response = await axios.post("/api/v1/referral-action/", {
        referral_id: referralId,
        action: "Approve",
        hr_remarks: hrRemarks,
        company_domain:
        userInfos?.user_details?.companies_data?.[0]?.company_domain ?? null
      })
      Swal.fire({
        icon: "success",
        title: "Approval Successful",
        text: "Candidate approved successfully!",
      })
      setCurrentPage(1);
      const updatedResponse = await axios.get("/api/v1/referral-list/")
      const referrals = updatedResponse.data.results.map(mapReferralRow);
      setAllReferralCandy(referrals)
      setViewCandidateApprovePopup(false)
      setHrRemarks("")
    } catch (error) {
      console.error("Error approving candidate:", error)
      let msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong"
      Swal.fire({
        icon: "error",
        title: "Approval Failed",
        text: msg,
      })
      setViewCandidateApprovePopup(false);
      setHrRemarks("");
    } finally {
      setLoading(false)
    }
  }
  const handleRejectRequest = async (referralId, hrRemarks) => {
    setLoading(true)
    try {
      const response = await axios.post("/api/v1/referral-action/", {
        referral_id: referralId,
        action: "Reject",
        hr_remarks: hrRemarks,
         company_domain:
        userInfos?.user_details?.companies_data?.[0]?.company_domain ?? null
      })
      Swal.fire({
        icon: "success",
        title: "Rejection Successful",
        text: "Candidate rejected successfully!",
      })
      setCurrentPage(1);
      const updatedResponse = await axios.get("/api/v1/referral-list/")
      const referrals = updatedResponse.data.results.map(mapReferralRow);
      setAllReferralCandy(referrals)
      setViewCandidateRejectPopup(false)
      setHrRemarksReject("")
    } catch (error) {
      console.error("Error rejecting candidate:", error)
      let msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong"
      Swal.fire({
        icon: "error",
        title: "Rejection Failed",
        text: msg,
      })
    } finally {
      setLoading(false)
    }
  }
  const handleViewCandidate = async id => {
    setLoadingAction(true)
    try {
      const response = await axios.get(`/api/v1/referral-action-details/${id}/`)
      setSelectedCandidate(response.data)
      setViewCandidateInfoPopup(true)
    } catch (error) {
      console.error("Error fetching candidate details:", error)
    } finally {
      setLoadingAction(false)
    }
  }
  const handleApproveCandidate = async id => {
    setLoadingAction(true)
    try {
      const response = await axios.get(`/api/v1/referral-action-details/${id}/`)
      setSelectedCandidateApprove(response.data)
      setViewCandidateApprovePopup(true)
    } catch (error) {
      console.error("Error fetching candidate details for approval:", error)
    } finally {
      setLoadingAction(false)
    }
  }
  const handleRejectCandidate = async id => {
    setLoadingAction(true)
    try {
      const response = await axios.get(`/api/v1/referral-action-details/${id}/`)
      setSelectedCandidateReject(response.data)
      setViewCandidateRejectPopup(true)
    } catch (error) {
      console.error("Error fetching candidate details for rejection:", error)
    } finally {
      setLoadingAction(false)
    }
  }
  useEffect(() => {
  setSelectedCandidateFilter(null);
  setSelectedJobFilter(null);
  setSelectedReferredByFilter(null);
  setSelectedStatusFilter(null);
}, []);
  const SelCandidateNameList = candidates.map(candidate => ({
    value: candidate.id,
    label: candidate.full_name,
  }))
  const SelJobNameList = jobs.map(job => ({
    value: job.job_id,
    label: job.job_title,
  }))
  const SelReferredByNameList = referredBy.map(person => ({
    value: person.id,
    label: person.full_name,
  }))
  const SelStatusList = statuses.map(status => ({
    value: status,
    label: status,
  }))
 const columns = [
  {
    name: (
      <span className="fw-bold text-capitalize" title="SNo">
        SNo
      </span>
    ),
    width: "80px",
    selector: (row, index) => index + 1,
    sortable: true,
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Referral By">
        Referral By
      </span>
    ),
    selector: (row) => row.job_reference_by,
    cell: (row) => (
      <span title={row.job_reference_by} className="Referral_JobTitle">
        {row.job_reference_by || "--"}
      </span>
    ),
    sortable: true,
    width: "170px",
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Referral Emp ID">
        Referral Emp ID
      </span>
    ),
    selector: (row) => row.job_reference_ID,
    cell: (row) => (
      <span title={row.job_reference_ID} className="Referral_JobTitle">
        {row.job_reference_ID || "--"}
      </span>
    ),
    sortable: true,
    width: "170px",
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Candidate Name">
        Candidate Name
      </span>
    ),
    cell: (row) => (
      row.resume ? (
        <a
          href={row.resume}
          target="_blank"
          rel="noopener noreferrer"
          className="blue_text text-decoration-underline"
          title="Click to view resume"
        >
          {row.job_candidate_name || "--"}
        </a>
      ) : (
        <span title={row.job_candidate_name}>
          {row.job_candidate_name || "--"}
        </span>
      )
    ),
    sortable: true,
  }
,
  {
    name: (
      <span className="fw-bold text-capitalize" title="Job ID">
        Job ID
      </span>
    ),
    selector: (row) => row.job_id,
    cell: (row) => (
      <span title={row.job_id || "--"} className="Referral_JobTitle text-nowrap">
        {row.job_id || "--"}
      </span>
    ),
    sortable: true,
    width: "120px",
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Job Title">
        Job Title
      </span>
    ),
    selector: (row) => row.job_title,
    cell: (row) => (
      <span title={row.job_title || "--"} className="Referral_JobTitle text-nowrap">
        {row.job_title || "--"}
      </span>
    ),
    sortable: true,
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Referred On">
        Referred On
      </span>
    ),
    selector: (row) => row.referred_on,
    cell: (row) => <span title={row.referred_on || "--"}>{row.referred_on || "--"}</span>,
    sortable: true,
    width: "150px",
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Status">
        Status
      </span>
    ),
    selector: (row) => row.referreal_select_status,
    cell: (row) => (
      <span title={row.referreal_select_status}>
        {row.referreal_select_status === "Approved" ? (
          <span className="badge text-bg-success" style={{ fontSize: "12px", fontWeight: "400" }}>
            {row.referreal_select_status || "--"}
          </span>
        ) : row.referreal_select_status === "Pending" ? (
          <span className="badge text-bg-primary" style={{ fontSize: "12px", fontWeight: "400" }}>
            {row.referreal_select_status || "--"}
          </span>
        ) : (
          <span className="badge text-bg-danger" style={{ fontSize: "12px", fontWeight: "400" }}>
            {row.referreal_select_status || "--"}
          </span>
        )}
      </span>
    ),
    sortable: true,
    width: "120px",
  },
  {
    name: (
      <span className="fw-bold text-capitalize" title="Action">
        Action
      </span>
    ),
    cell: (row) => (
      <div className="text-start d-flex">
        {row.referreal_select_status === "Approved" ? (
          <div>
            <button
              className="btn btn-secondary btn-sm my-2 me-2 bi bi-pencil-square"
              id="Referral_ViewBtn"
              onClick={() => handleViewCandidate(row.id)}
            >
              View Details
            </button>
          </div>
        ) : row.referreal_select_status === "Pending" ? (
          <div>
            <button
              className="btn btn-secondary btn-sm my-2 me-2 bi bi-pencil-square"
              id="Referral_ViewBtn"
              onClick={() => handleViewCandidate(row.id)}
            >
              View
            </button>
            <button
              className="btn btn-success btn-sm my-2 me-2 bi bi-pencil-square"
              id="Referral_ApprovalBtn"
              onClick={() => handleApproveCandidate(row.id)}
            >
              Approve
            </button>
            <button
              className="btn btn-danger btn-sm my-2 me-2 bi bi-pencil-square"
              id="Referral_RejectBtn"
              onClick={() => handleRejectCandidate(row.id)}
            >
              Reject
            </button>
          </div>
        ) : (
          <div>
            <button
              className="btn btn-secondary btn-sm my-2 me-2 bi bi-pencil-square"
              id="Referral_ViewBtn"
              onClick={() => handleViewCandidate(row.id)}
            >
              View Details
            </button>
          </div>
        )}
      </div>
    ),
    sortable: false,
  },
];
  return (
    <>
      <div
        className="page-content allact-tabs manager-dash"
        id="AllReferralCandidatesContainer"
      >
        <Container fluid>
          <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
            <Row>
              <Col xxl={12}>
                <h1 className="page-title mb-4">All Referral Candidates</h1>
              </Col>
            </Row>
            <Card className="mb-3 shadow-md border-0 p-2">
              <Row>
                <Col xl={2} lg={6} md={6} sm={6} className="mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Candidate Name
                  </label>
                  <Select
                    options={SelCandidateNameList}
                    styles={customStylesForRectSelect}
                    placeholder="Select"
                    onChange={setSelectedCandidateFilter}
                    value={selectedCandidateFilter}
                    isLoading={loadingDropdown}
                  />
                </Col>
                <Col xl={2} lg={6} md={6} sm={6} className="mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Jobs
                  </label>
                  <Select
                    options={SelJobNameList}
                    styles={customStylesForRectSelect}
                    placeholder="Select"
                    onChange={setSelectedJobFilter}
                    value={selectedJob}
                    isLoading={loadingDropdown}
                  />
                </Col>
                <Col xl={2} lg={6} md={6} sm={6} className="mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referred By
                  </label>
                  <Select
                    options={SelReferredByNameList}
                    styles={customStylesForRectSelect}
                    placeholder="Select"
                    onChange={setSelectedReferredByFilter}
                    value={selectedReferredBy}
                    isLoading={loadingDropdown}
                  />
                </Col>
                <Col xl={2} lg={6} md={6} sm={6} className="mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Status
                  </label>
                  <Select
                    options={SelStatusList}
                    styles={customStylesForRectSelect}
                    placeholder="Select"
                    onChange={setSelectedStatusFilter}
                    value={selectedStatus}
                    isLoading={loadingDropdown}
                  />
                </Col>
                <Col
                  xl={4}
                  lg={12}
                  className="text-xl-start text-lg-end  text-end"
                >
                  <Button
                    className="btn border blueBtn mt-4"
                    onClick={() => {
                      setSelectedCandidateFilter(null)
                      setSelectedJobFilter(null)
                      setSelectedReferredByFilter(null)
                      setSelectedStatusFilter(null)
                    }}
                  >
                    Reset 
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xxl={12} className="mt-4">
                  <div
                    className="AllReferralCandidates_TableView"
                    id="AllReferralCandidates_TableView"
                  >
                    <DataTable
                      columns={columns}
                      data={AllReferralCandy}
                      pagination
                      paginationServer
                      paginationTotalRows={totalCount}
                      fixedHeader
                      fixedHeaderScrollHeight="500px"
                      onChangePage={page => setCurrentPage(page)}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={rows => {
                        setRowsPerPage(rows);
                        setCurrentPage(1); 
                      }}
                      paginationPerPage={rowsPerPage}
                      paginationComponentOptions={paginationComponentOptions}
                      progressPending={loadingList}
                      progressComponent={<OrgTableShimmer columns={6} rows={6} titleWidth="220px" />}
                      persistTableHead
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </Container>
      </div>
      {/* Candidate Details Modal */}
      <Modal
        size="lg"
        isOpen={ViewCandidateInfoPopup}
        toggle={() => setViewCandidateInfoPopup(false)}
      >
        <ModalHeader
          toggle={() => setViewCandidateInfoPopup(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Candidate Details
        </ModalHeader>
        <ModalBody className="text-start">
          <div className="py-3">
            <Row>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral By
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.referral_by
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral Emp ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.referral_emp_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Candidate Name
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.candidate_name
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.job_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Title
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.job_title
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referred On
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.referred_on
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Status
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.status
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Referral Amount
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate &&
                      selectedCandidate.details.referral_amount
                        ? selectedCandidate.details.referral_amount
                        : "N/A"
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Referral Disbursed
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.referral_disbursed
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Referral Disbursed At
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate &&
                      selectedCandidate.details.referral_disbursed_at
                        ? new Date(
                            selectedCandidate.details.referral_disbursed_at
                          ).toLocaleDateString()
                        : "--"
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Actioned By
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate
                        ? selectedCandidate.details.actioned_by
                        : "--"
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Actioned At
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate && selectedCandidate.details.actioned_at
                        ? new Date(
                            selectedCandidate.details.actioned_at
                          ).toLocaleDateString()
                        : "--"
                    }
                  />
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize me-2">
                    Resume
                  </label>
                  {selectedCandidate && selectedCandidate.details.resume ? (
                    <Link target="_blank" to={selectedCandidate.details.resume}>
                      View Resume
                    </Link>
                  ) : (
                    <span>No Resume</span>
                  )}
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Comments
                  </label>
                  <textarea
                    rows={3}
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidate && selectedCandidate.details.hr_remarks
                        ? selectedCandidate.details.hr_remarks
                        : "No Comments"
                    }
                  ></textarea>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            className="btn border blueBtn"
            onClick={() => {
              setViewCandidateInfoPopup(false)
              setSelectedCandidate(null)
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        size="lg"
        isOpen={ViewCandidateApprovePopup}
        toggle={() => setViewCandidateApprovePopup(false)}
      >
        <ModalHeader
          toggle={() => setViewCandidateApprovePopup(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Approve Candidate
        </ModalHeader>
        <ModalBody className="text-start">
          <div className="py-3">
            <Row>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral By
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.referral_by
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral Emp ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.referral_emp_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Candidate Name
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.candidate_name
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.job_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Title
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.job_title
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referred On
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.referred_on
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Status
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove
                        ? selectedCandidateApprove.details.status
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Referral Amount
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateApprove &&
                      selectedCandidateApprove.details.referral_amount
                        ? selectedCandidateApprove.details.referral_amount
                        : "N/A"
                    }
                  />
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize me-2">
                    Resume
                  </label>
                  {selectedCandidateApprove &&
                  selectedCandidateApprove.details.resume ? (
                    <Link
                      target="_blank"
                      to={selectedCandidateApprove.details.resume}
                    >
                      View Resume
                    </Link>
                  ) : (
                    <span>No Resume</span>
                  )}
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Comments
                  </label>
                  <textarea
                    rows={3}
                    className="form-control"
                    placeholder="Comments"
                    value={hrRemarks}
                    onChange={e => setHrRemarks(e.target.value)}
                  ></textarea>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            className="btn border blueBtn"
            onClick={() => setViewCandidateApprovePopup(false)}
          >
            Close
          </Button>
          <Button
            className="btn border btn-success"
            onClick={() => {
              handleApproveRequest(
                selectedCandidateApprove.details.id,
                hrRemarks
              )
            }}
            disabled={loading}
          >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Approving...
            </>
          ) : (
            "Approve"
          )}
        </Button>
        </ModalFooter>
      </Modal>
      {/* Reject Candidate Modal */}
      <Modal
        size="lg"
        isOpen={ViewCandidateRejectPopup}
        toggle={() => setViewCandidateRejectPopup(false)}
      >
        <ModalHeader
          toggle={() => setViewCandidateRejectPopup(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Reject Candidate
        </ModalHeader>
        <ModalBody className="text-start">
          <div className="py-3">
            <Row>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral By
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.referral_by
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referral Emp ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.referral_emp_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Candidate Name
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.candidate_name
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job ID
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.job_id
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Title
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.job_title
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Referred On
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.referred_on
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Status
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject
                        ? selectedCandidateReject.details.status
                        : "Loading..."
                    }
                  />
                </div>
              </Col>
              <Col xxl={6}>
                <div className="FormGroup mb-3">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Job Referral Amount
                  </label>
                  <input
                    type="text"
                    readOnly
                    className="form-control bg-light"
                    value={
                      selectedCandidateReject &&
                      selectedCandidateReject.details.referral_amount
                        ? selectedCandidateReject.details.referral_amount
                        : "N/A"
                    }
                  />
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize me-2">
                    Resume
                  </label>
                  {selectedCandidateReject &&
                  selectedCandidateReject.details.resume ? (
                    <Link
                      target="_blank"
                      to={selectedCandidateReject.details.resume}
                    >
                      View Resume
                    </Link>
                  ) : (
                    <span>No Resume</span>
                  )}
                </div>
              </Col>
              <Col xxl={12}>
                <div className="FormGroup">
                  <label className="form-field-label font_weight_500 text-capitalize">
                    Comments
                  </label>
                  <textarea
                    rows={3}
                    className="form-control"
                    placeholder="Comments"
                    value={hrRemarksReject}
                    onChange={e => setHrRemarksReject(e.target.value)}
                  ></textarea>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            className="btn border blueBtn"
            onClick={() => {
              setViewCandidateRejectPopup(false)
              setHrRemarksReject("")
            }}
          >
            Close
          </Button>
          <Button
            className="btn border btn-danger"
            onClick={() => {
              handleRejectRequest(
                selectedCandidateReject.details.id,
                hrRemarksReject
              )
            }}
             disabled={loading}
          >
           {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Rejecting...
              </>
            ) : (
              "Reject"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}
export default AllReferralCandidates
